import Utils from "../pages/Utility";
const API_URL = Utils.API_URL;

export async function get(url, data) {
  // return await axiosApi.get(url, { ...config }).then(response => response.data)
  return fetch(API_URL + url, {
    method: "GET",
    headers: {
      // mode: 'no-cors',
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bareer " + data?.token,
    },
    // body: JSON.stringify(data)
  }).then((res) => res.json());
}

export async function download(url, data) {
  // return await axiosApi.get(url, { ...config }).then(response => response.data)
  return fetch(API_URL + url, {
    method: "GET",
    headers: {
      // mode: 'no-cors',
      Accept: "application/zip",
      "Content-Type": "application/json",
      Authorization: "Bareer " + data?.token,
    },
    // body: JSON.stringify(data)
  }).then((res) => res.blob());
}

export async function post(url, data) {
  // console.log('post method req', url, data)
  return fetch(API_URL + url, {
    method: "POST",
    headers: {
      // mode: 'no-cors',
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bareer " + data?.token,
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
  // .post(API_URL+url, { ...data }, { ...config })
  // .then(response => response.data)
}

export async function put(url, data) {
  console.log("put method req", url, data);
  return fetch(API_URL + url, {
    method: "PUT",
    headers: {
      // mode: 'no-cors',
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bareer " + data?.token,
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export async function upload(folderOrUrl, data, type, onProgress) {
  let endpoint = "/upload";
  let formData;
  let progressCallback = typeof onProgress === "function" ? onProgress : null;

  // Check if called with (url, formData)
  if (typeof folderOrUrl === "string" && folderOrUrl.startsWith("/")) {
    endpoint = folderOrUrl;
    formData = data instanceof FormData ? data : new FormData();
    if (typeof type === "function" && !progressCallback) {
      progressCallback = type;
    }
  } else {
    // Called with (folder, file, type, onProgress)
    formData = new FormData();
    const folder = folderOrUrl || "pdf";
    formData.append("folder", folder);
    if (data instanceof FormData) {
      formData = data;
    } else if (data) {
      formData.append("file", data);
      formData.append("image", data);
      formData.append("pdf", data);
    }
    if (typeof type === "function" && !progressCallback) {
      progressCallback = type;
    }
  }

  if (progressCallback) {
    progressCallback(30);
  }

  const targetUrl = API_URL + endpoint;
  console.log("Uploading file via fetch to:", targetUrl);

  try {
    if (progressCallback) {
      progressCallback(60);
    }

    const response = await fetch(targetUrl, {
      method: "POST",
      body: formData,
    });

    if (progressCallback) {
      progressCallback(100);
    }

    const result = await response.json();
    console.log("Upload response received:", result);

    if (response.ok && (result?.statusCode === 200 || result?.url || result?.data)) {
      const fileUrl = result?.data || result?.url;
      return {
        statusCode: 200,
        data: fileUrl,
        url: fileUrl,
        message: "SUCCESS",
      };
    } else {
      const errMsg = result?.error || result?.message || "Upload failed";
      throw new Error(errMsg);
    }
  } catch (error) {
    console.error("Local file upload error:", error);
    throw (error?.message || "Network error during file upload");
  }
}

export async function del(url, config = {}) {
  // return await axiosApi
  //   .delete(url, { ...config })
  //   .then(response => response.data)
}
